/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Link } from '@coursera/cds-core';
import { EditIcon } from '@coursera/cds-icons';

import { PAYMENT_METHOD_SETTINGS_LINK } from 'bundles/my-purchases-graphql/lib/constants';

import _t from 'i18n!nls/my-purchases-graphql';

const UpdatePaymentMethodLink = () => {
  return (
    <Link
      variant="quiet"
      typographyVariant="bodySecondary"
      icon={<EditIcon size="small" />}
      iconPosition="before"
      href={PAYMENT_METHOD_SETTINGS_LINK}
    >
      {_t('Update payment method')}
    </Link>
  );
};

export default UpdatePaymentMethodLink;
